import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletCaptionSubject,
  PortletFooter,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import { withTranslation } from 'react-i18next';
import {
  Col,
  FormControl,
  Row,
} from 'react-bootstrap';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import ReasonCodeSelection from '../../components/ResonCodeSelection/ReasonCodeSelection';

const VoidTicket = observer((props) => {
  const { t } = props;
  const [voidOptionValue, setVoidOptionValue] = useState(1);
  const [voidReason, setVoidReason] = useState();
  const [saving, setSaving] = useState(false);
  const [isVoided, setIsVoided] = useState(false);
  const { ticket } = props;
  const { ticketStore, notifierStore, materialStore, scheduleStore } = useStores();
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const voidTicket = () => {
    if (ticket.isOffline) {
      scheduleStore.removeOfflineTicket(ticket.id)
        .then(() => ticketStore.loadTickets());
      return;
    }

    const clearInventory = voidOptionValue === 2;
    setSaving(true);

    ticketStore.voidTicket(ticket.id, voidReason, clearInventory)
      .then(() => {
        if (isMounted.current) {
          setIsVoided(true);
        }

        ticketStore.loadTickets();

        if (clearInventory) {
          materialStore.loadMaterials(true);
        }
      })
      .catch(e => notifierStore.showError(e.message || 'API error'))
      .finally(() => {
        if (isMounted.current) {
          setSaving(false);
        }
      });
  };

  return (
    <Portlet className="ticket-details">
      <PortletTitle>
        <PortletCaption icon={'fa-file-text-o'}>
          <PortletCaptionSubject>
            {t('Ticket')} {ticket.dispatchTicketCode ? ticket.dispatchTicketCode : ticket.id} {ticket.isDemo ? (
              <span
                className={'ticket-demo'}>{t('Demo')}
              </span>
            ) : ''} {ticket.isVoided || isVoided ? <span className={'ticket-voided'}>{t('Voided')}</span> : ''}
          </PortletCaptionSubject>
        </PortletCaption>
      </PortletTitle>
      <PortletBody>
        {!ticket.isVoided && !isVoided && !ticket.isOffline && (
          <Row className="void-option margin-bottom-15">
            <Col sm={4}>
              <ReasonCodeSelection reasonCode={materialStore.reasonCode} onChange={(reason) => {
                setVoidReason(reason);
              }}/>
              <FormControl
                name="voidOptionValue"
                componentClass="select"
                value={voidOptionValue}
                onChange={e => {
                  setVoidOptionValue(Number(e.target.value));
                }}
                bsSize="sm"
              >
                <option value={1}>{t('Void with Inventory')}</option>
                <option value={2}>{t('Void with No Inventory')}</option>
              </FormControl>
            </Col>
          </Row>
        )}
      </PortletBody>
      <PortletFooter>
        {!ticket.isVoided && !isVoided && (
          <LoadingButton
            bsStyle="primary"
            label={t('Void')}
            loadingLabel={t('Voiding')}
            isLoading={saving}
            onClick={() => voidTicket()}/>
        )}
      </PortletFooter>
    </Portlet>
  );
});

export default withTranslation()(VoidTicket);
